module.exports = __webpack_public_path__ + "static/img/banner06.f39c7d96.webp";